/** @module wgfractals/util/result */

// Generic typed-array readback (here always Uint32Array: one packed pixel each).

/**
 * Maps `readBuffer` for CPU access, copies its contents into a new typed array, then unmaps.
 * The `.slice()` is required — `getMappedRange()` returns a view into the mapped GPU memory
 * which becomes invalid after `unmap()`, so we copy it out before unmapping.
 * @param {GPUBuffer} readBuffer - a `MAP_READ` buffer produced by `stageReadback`
 * @param {typeof Uint32Array} [readbackType=Uint32Array] - typed array constructor for the result
 * @returns {Promise<Uint32Array>}
 */
export async function extractResult(readBuffer, readbackType = Uint32Array) {
  try {
    await readBuffer.mapAsync(GPUMapMode.READ);
    const result = new readbackType(readBuffer.getMappedRange().slice());
    readBuffer.unmap();
    return result;
  } finally {
    readBuffer.destroy();
  }
}
